/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.15.0
 */

import { createAction } from '../app/createAction';
import {
    ONBOARDING_DISABLE,
    ONBOARDING_DISABLE_ALL,
    ONBOARDING_ENABLE,
    ONBOARDING_FINISH,
    ONBOARDING_INIT_START,
    ONBOARDING_INIT_SUCCESS,
    ONBOARDING_MODAL_VIEWED,
    ONBOARDING_NEXT_STEP,
    ONBOARDING_PAGE_READY_FOR_START,
    ONBOARDING_SET_CURRENT_STEP,
    ONBOARDING_SHOW_LATER,
    ONBOARDING_SKIP,
    ONBOARDING_START,
} from './onboardingConstants';
import {
    IOnboardingInitStartPayload,
    IOnboardingModalViewedPayload,
    IOnboardingNextStepPayload,
    IOnboardingSetCurrentStepPayload,
    TOnboardingDisableAction,
    TOnboardingDisableAllAction,
    TOnboardingEnableAction,
    TOnboardingFinishAction,
    TOnboardingFinishPayload,
    TOnboardingInitStartAction,
    TOnboardingInitSuccessAction,
    TOnboardingInitSuccessPayload,
    TOnboardingModalViewedAction,
    TOnboardingNextStepAction,
    TOnboardingPageReadyForStartAction,
    TOnboardingSetCurrentStepAction,
    TOnboardingShowLaterAction,
    TOnboardingSkipAction,
    TOnboardingStartAction,
} from './types/onboardingActionTypes';

export const onboardingInitStartAction = (payload: IOnboardingInitStartPayload): TOnboardingInitStartAction =>
    createAction(ONBOARDING_INIT_START, payload);

export const onboardingInitSuccessAction = (payload: TOnboardingInitSuccessPayload): TOnboardingInitSuccessAction =>
    createAction(ONBOARDING_INIT_SUCCESS, payload);

export const onboardingPageReadyForStartAction = (): TOnboardingPageReadyForStartAction =>
    createAction(ONBOARDING_PAGE_READY_FOR_START);

export const onboardingStartAction = (): TOnboardingStartAction =>
    createAction(ONBOARDING_START);

export const onboardingSkipAction = (): TOnboardingSkipAction =>
    createAction(ONBOARDING_SKIP);

export const onboardingFinishAction = (payload?: TOnboardingFinishPayload): TOnboardingFinishAction =>
    createAction(ONBOARDING_FINISH, payload);

export const onboardingShowLaterAction = (): TOnboardingShowLaterAction =>
    createAction(ONBOARDING_SHOW_LATER);


export const onboardingNextStepAction = (payload: IOnboardingNextStepPayload): TOnboardingNextStepAction =>
    createAction(ONBOARDING_NEXT_STEP, payload);

export const onboardingSetCurrentStepAction = (payload: IOnboardingSetCurrentStepPayload):
    TOnboardingSetCurrentStepAction =>
    createAction(ONBOARDING_SET_CURRENT_STEP, payload);

export const onboardingModalViewedAction = (payload: IOnboardingModalViewedPayload): TOnboardingModalViewedAction =>
    createAction(ONBOARDING_MODAL_VIEWED, payload);


export const onboardingEnableAction = (): TOnboardingEnableAction =>
    createAction(ONBOARDING_ENABLE);

export const onboardingDisableAction = (): TOnboardingDisableAction =>
    createAction(ONBOARDING_DISABLE);

export const onboardingDisableAllAction = (): TOnboardingDisableAllAction =>
    createAction(ONBOARDING_DISABLE_ALL);
